module.exports = __webpack_public_path__ + "fonts/gothica1-black-webfont.8bc3a98.woff";